module.exports = __webpack_public_path__ + "fonts/KaTeX_Size4-Regular.61522cd3.woff2";